import React, { useState } from 'react';
import { Button } from 'app/shared/components';
import { useSurveyConfig } from 'app/core/survey-config';
import { usePreviewAnswer } from 'app/modules/survey';
import PreviewModal from './PreviewModal';

export interface PreviewAnswerProsp {
  className?: string;
}

export default function PreviewAnswer({ className }: PreviewAnswerProsp) {
  const [open, setOpen] = useState(false);
  const [previewAnswer, disabled, data] = usePreviewAnswer(setOpen);
  const { wording } = useSurveyConfig();

  return (
    <>
      <PreviewModal data={data} open={open} setOpen={setOpen} />
      <Button
        className={className}
        color="primary"
        disabled={disabled}
        onClick={previewAnswer}
      >
        {wording.common.action.submit}
      </Button>
    </>
  );
}
